/* unplugin-vue-components disabled */import { render } from "./fontstyle.vue?vue&type=template&id=3931ee72&scoped=true"
import script from "./fontstyle.vue?vue&type=script&lang=js"
export * from "./fontstyle.vue?vue&type=script&lang=js"

import "./fontstyle.vue?vue&type=style&index=0&id=3931ee72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3931ee72"]])

export default __exports__